import { $api } from "../generated/client";

export default function useGetImportTasks(shopId: string, jobId: string) {
  return $api.useQuery("get", "/shops/{shopId}/imports/{importId}", {
    params: { path: { shopId, importId: jobId } }
  })
}
